import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { PasswordValidationCallbacks } from "@/services/misc/functions/ValidationFunctions";

export class CreateUserForm {
  public username: string = '';
  public databaseId: number = 0;
  public password: string = '';
  public passwordConf: string = '';

  public rules: { [key: string]: FormValidationFunction[] } = {
    username: [
      (v: string) => !!v || 'Name is required',
      (v: string) => v.length <= 24 || 'Name can be at most 24 characters',
      (v: string) => v.length >= 3 || 'Name has to be at least 3 characters',
      (v: string) => !v || /^[a-zA-Z0-9]+$/.test(v) || 'Name must contain only letters and numbers',
    ],
    databaseId: [
      (v: number) => !!v || 'Database id is required',
      (v: number) => v > 0 || 'Database id must be greater than 0',
    ],
    password: [
      (v: string) => !!v || 'Password is required',
      ...PasswordValidationCallbacks,
    ],
  };
}
